<section class="">
  <app-demo-alert *ngIf="isDemoMode"></app-demo-alert>
  <div id="backdrop" class="w-100 backdrop d-none"></div>
  <ngx-spinner
    bdColor="rgba(0, 0, 0, 0.09)"
    color="#0D6938"
    type="ball-scale-multiple"
  >
  </ngx-spinner>
  <app-modal></app-modal>
  <router-outlet></router-outlet>
</section>
